/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { setScheduledTask } from "../../../../store/api/tasks/reducer";
import { setErrorMsg } from "../../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../../store/hooks";
import AutocompleteSelect from "../../../Shared/Dropdown/AutocompleteSelect";
import { IOption } from "../../../Shared/Filter/types";
import { getNewOptions } from "../../helpers";
import { Link } from "react-router-dom";
import { useAuditReport } from "./hooks";
import { RadixSelectControl } from "../../../ui/radix-select";
import { Label } from "../../../ui/label";
import { auditReportTypeValues } from "../../../../globals/constants";

const AuditReports = () => {
  const dispatch = useStoreDispatch();

  const {
    errorMsg,
    scheduledtasks,
    emailGroupNameOptions = [],
    emailGroupName,
    setEmailGroupName,
    auditReportList,
  } = useAuditReport();

  const mappedReportOptions = auditReportList
    .map((item: any) => {
      const option =
        typeof item === "object"
          ? { value: item.value, label: item.text || item.label || item.value }
          : { value: item, label: item };
      return option;
    })
    .filter(
      (option: { value: string; label: string }) =>
        option.value !== auditReportTypeValues.customAuditReport &&
        option.label !== auditReportTypeValues.customAuditReportLabel
    );

  const onChangeHandler = (value: string) => {
    dispatch(setScheduledTask({ auditReportType: value }));
    dispatch(setErrorMsg({ ...errorMsg, auditReportType: "" }));
  };

  const autocompleteSelectHandler = (event: any, newValue: IOption[] | null) => {
    setEmailGroupName(newValue || []);
    dispatch(setScheduledTask({ emailGroupName: newValue?.map((item) => item.value).toString() }));
  };

  const noOption = (
    <p>
      {`No email group available. `}
      <Link className="nooption-link" to={"/administration/email"}>
        "Click here"
      </Link>
      {` to add an email group.`}
    </p>
  );

  return (
    <div className="flex flex-col gap-6">
      <div className="space-y-2">
        <Label>Audit Report Type</Label>
        <RadixSelectControl
          options={[
            { value: auditReportTypeValues.none, label: auditReportTypeValues.none },
            ...mappedReportOptions,
          ]}
          value={scheduledtasks.auditReportType || auditReportTypeValues.none}
          placeholder="__placeholder__"
          onValueChange={onChangeHandler}
        />
      </div>
      <div className="space-y-2">
        <Label>Email Group Name</Label>
        <AutocompleteSelect
          name="emailGroupName"
          value={emailGroupName}
          multiple={true}
          id="emailGroupName"
          options={getNewOptions(emailGroupNameOptions, emailGroupName)}
          label={""}
          size={"small"}
          noOptionsText={noOption}
          onChange={autocompleteSelectHandler}
          disablePortal
        />
      </div>
    </div>
  );
};

export default AuditReports;
